export function getLast12Months(
    values: { period: string; value: number | null }[] | undefined,
): number | null {
    if (!values || values.length === 0) {
        return null;
    }

    const sortedValues = values
        .slice()
        .sort((a, b) => a.period.localeCompare(b.period));

    const last12Months = sortedValues.slice(-12);

    const hasValidValue = last12Months.some((item) => item.value !== null);
    if (!hasValidValue) {
        return null;
    }

    return last12Months.reduce((sum, item) => sum + (item.value ?? 0), 0);
}

export function getLastValue<T extends { period: string; value: any | null }>(
    values: T[] | undefined,
): T | null | undefined {
    if (!values || values.length === 0) {
        return null;
    }

    const validValues = values
        .filter(
            (item) =>
                item.value !== null &&
                item.value !== "N/A" &&
                item.value !== "nan" &&
                item.value !== "NaT",
        )
        .sort((a, b) => a.period.localeCompare(b.period));

    if (validValues.length === 0) {
        return null;
    }

    return validValues[validValues.length - 1];
}
